import { CheckCircle2, FileSearch, Briefcase, Wallet } from "lucide-react";

const STEPS = [
    {
        num: "01",
        icon: CheckCircle2,
        title: "Check your eligibility",
        desc: "Answer a few quick questions about your claim — takes under 60 seconds, no upfront cost, completely free.",
    },
    {
        num: "02",
        icon: FileSearch,
        title: "We assess your case",
        desc: "Our specialists review the facts, request any documents we need and confirm whether you have a strong claim.",
    },
    {
        num: "03",
        icon: Briefcase,
        title: "We handle everything",
        desc: "Sit back. We deal with the lender, landlord, insurer or business — keeping you updated every step of the way.",
    },
    {
        num: "04",
        icon: Wallet,
        title: "You get paid",
        desc: "When we win, compensation is paid directly to you. Our success fee only applies if your claim succeeds.",
    },
];

export default function HowItWorks({ dark = false }) {
    return (
        <section className={`section-pad ${dark ? "bg-navy-900 text-white" : "bg-white"}`}>
            <div className="container-x">
                <div className="max-w-2xl">
                    <span className={dark ? "text-eyebrow-light" : "text-eyebrow"}>How it works</span>
                    <h2 className={`mt-3 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight ${dark ? "text-white" : "text-navy-900"}`}>
                        Four simple steps from query to <span className="text-emerald-500">compensation</span>.
                    </h2>
                    <p className={`mt-5 text-base ${dark ? "text-slate-300" : "text-slate-600"} leading-relaxed`}>
                        We&apos;ve cut every ounce of paperwork. Most clients spend less than 10 minutes start-to-finish — we do the heavy lifting.
                    </p>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {STEPS.map((s) => (
                        <div
                            key={s.num}
                            className={`relative rounded-2xl p-7 border transition-all duration-300 ${dark
                                ? "bg-white/[0.03] border-white/10 hover:border-emerald-400/40"
                                : "bg-slate-50 border-slate-200 hover:border-emerald-300 hover:-translate-y-1 hover:shadow-card-soft"
                                }`}
                        >
                            <div className={`absolute -top-3 left-7 px-2.5 py-1 rounded-md text-[11px] font-mono font-bold tracking-wider ${dark ? "bg-emerald-500 text-navy-900" : "bg-navy-900 text-emerald-300"}`}>
                                STEP {s.num}
                            </div>
                            <s.icon className={`w-9 h-9 ${dark ? "text-emerald-400" : "text-emerald-600"}`} />
                            <h3 className={`mt-5 text-xl font-display font-semibold ${dark ? "text-white" : "text-navy-900"}`}>{s.title}</h3>
                            <p className={`mt-2.5 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>{s.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
